import {
  Box,
  Paper,
  PaperProps,
  styled,
  Tooltip,
  Typography,
} from "@mui/material";

import { useTranslation } from "react-i18next";

import { CustomGraph } from "components/result/resultGraphs/CustomGraph";
import { Info } from "@mui/icons-material";
import { formatDate } from "utils/DateUtils";

interface Props extends PaperProps {
  score: number;
  computationDate?: number;
  computationVersion?: string;
}

export function TotalResult(props: Props) {
  const { score, computationDate, computationVersion, ...paperProps } = props;
  const { t } = useTranslation();

  return (
    <StyledPaper {...paperProps}>
      <Box className="header">
        <div className="header-label">
          <Typography variant="h1" component="h1">
            {t("label.myClimateAdaptationScore")}
          </Typography>
          <Tooltip title={t("label.myClimateAdaptationInfo")}>
            <Info fontSize="medium" color="primary" />
          </Tooltip>
          <Tooltip title={t("label.moreInfoAboutScoresInfo")}>
            <Typography className="custom-info-link">
              {t("label.moreInfoAboutScores")}
            </Typography>
          </Tooltip>
        </div>
        {computationDate && computationVersion && (
          <div className="version-date">
            <Typography variant="small-italic">
              Laatst bijgewerkt op: {formatDate(computationDate)}
            </Typography>
            <Typography variant="small-italic">
              Versie: {computationVersion}
            </Typography>
          </div>
        )}
      </Box>
      <CustomGraph score={score} />
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(10)};
  padding-left: 15%;
  padding-right: 15%;
  align-items: center;
  .header {
    width: fit-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    .header-label {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: ${({ theme }) => theme.spacing(2)};
    }
    .version-date {
      display: flex;
      gap: ${({ theme }) => theme.spacing(1)};
    }

    .custom-info-link {
      color: ${({ theme }) => theme.palette.primary.main};
      cursor: default;
      text-decoration: underline;
      text-decoration-style: dashed;
    }
  }
`;
